import React, { FC, useEffect, useState } from "react";
import { Row, Col , Collapse, Spin} from "antd";
import "./star-gaps.scss";
import PinUnpin from "../../pin-unpin-component";
// import {formatDate} from "../../../utils/utils";
import { formatDisplayDate } from "@utils/helpers";
import CustomTooltip from "../../../tool-tip";
// import moment from "moment";
import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";
import { cloneDeep } from 'lodash'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";
const { Panel } = Collapse;

const StarGap: FC<any> = (props) => {

  const dataCardId = "28";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=> {
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props?.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  const genExtra = (id: any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds} />;


  const gapBetweenDays = (date : any) => {
    let date2 = new Date();
    let date1 = new Date(date);
    let diff = Math.floor(date1?.getTime() - date2?.getTime());
    let day = 1000 * 60 * 60 * 24;
    let days = Math.floor(diff/day);
    let days1 = Math.floor((diff/day)%30);
    let months = Math.floor(days/31);
    let years = Math.floor(months/12);
    let message = ""
    message += months > 0 ? months + " month(s) " : ""
    message += days1 > 0 ? days1 + " day(s) "  : ""
    message += years > 0 ? years + " year(s) " : ""
    message += (months || days1 || years) ? "to go" : ""
    return message
  }


  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  return (
    <>
      <Collapse accordion={true} activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
        <Panel className="title" header={getHeading("MyCare - Star Gaps")} key="1" extra={genExtra(dataCardId)} style={{ marginBottom: "8px" }}>
          {props.loading ? (
            <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}></Spin>
          ) : props?.data?.values?.length > 0 ? (
            <>
              <div>
                <Row style={{ marginBottom: "20px" }}>
                  <Col span={1}></Col>
                  <Col span={13} className="light-text">
                    {"Measure Name"}
                  </Col>
                  <Col span={5} className="light-text">
                    {"Completion Date"}
                    <CustomTooltip toolTipvalue={"Latest date of recommendation"} children={<span style={{ margin: "0px 5px" }} className="icon icon-info clr-lightGrayColor"></span>} />
                  </Col>
                  <Col span={5} className="light-text">
                    {"Due Date"}
                    <CustomTooltip toolTipvalue={"Due date of the exam for the recommendation"} children={<span style={{ margin: "0px 5px" }} className="icon icon-info clr-lightGrayColor"></span>} />
                  </Col>
                </Row>
                <div className="starContainer  custom-scroll-bar">
                  {props?.data?.values?.map((row: any, index: any) => (
                    <Row className="tableContainer">
                      <Col span={1} style={{ marginTop: "-3px" }}>
                        {row.testStatusFlag !== "Y" ? (
                          <CheckCircleFilled className={"green"} style={{ fontSize: "20px" }} />
                        ) : (
                          <ExclamationCircleFilled className={"orange-blink"} style={{ fontSize: "20px", paddingTop: "3px" }} />
                        )}
                      </Col>
                      <Col span={13} className="light-text fwnormal">
                        {row.testName}
                      </Col>
                      <Col span={5} style={{ fontSize: "16px", color: "#42526E" }}>
                        {row.completionDate ? formatDisplayDate(row.completionDate, "reminderDateActualFormat", "") : "No Data Yet"}
                      </Col>
                      <Col span={5} style={{ fontSize: "16px", textAlign: "center" }}>
                        <Row className="gapInMonths">{row.dueDate ? formatDisplayDate(row.dueDate, "reminderDateActualFormat", "") : "No Data Yet"}</Row>
                        <Row className="grey-text fwnormal">{row.dueDate && new Date(row.dueDate) > new Date() ? gapBetweenDays(row.dueDate) : ""}</Row>
                      </Col>
                    </Row>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <DataNotFound message={NO_DATA_FOUND} />
          )}
        </Panel>
      </Collapse>
    </>
  );
};

export default StarGap;
